import { FC } from 'react'
import { Logo, QRCodeContainer, TableName, ScanAndPay } from './styled'
import { QRCodeCanvas } from 'qrcode.react'
import { RenderIf } from 'shared/helpers/renderIf'
import { useGlobalStore } from 'shared/store/globalSlice'
import { useQrCodeStore } from 'shared/store/qrCodeSlice'
import { useConfigStore } from 'shared/store/configSlice'
import { getAppName } from 'shared/helpers/getAppName'

export const DefaultLayout: FC = () => {
  const isCC = useGlobalStore().isCCSelected
  const { qrCodeValue, selectedCaption } = useQrCodeStore()
  const interfaceConfig = useConfigStore().config?.interfaceConfig

  return (
    <>
      <Logo src={interfaceConfig?.[getAppName(isCC)]?.logoImage} alt='logo' />
      <QRCodeContainer>
        <QRCodeCanvas value={qrCodeValue} size={105} />
      </QRCodeContainer>
      <RenderIf condition={isCC}>
        <ScanAndPay isClickCollect={isCC}>Scannen & Vorbestellen</ScanAndPay>
      </RenderIf>
      <RenderIf condition={!isCC}>
        <TableName>Tisch Nr. {selectedCaption}</TableName>
        <ScanAndPay isClickCollect={isCC}>Scan & Pay</ScanAndPay>
      </RenderIf>
    </>
  )
}
